<template>
  <fb-form-properties-manager :fields="fields" :formId="formId" />
</template>

<script>
export default {
  name: "FormHeaderV1Properties",
  props: ["formId"],
  data() {
    return {
      fields: [
        {
          type: "richEditor",
          properties: {
            label: "Default value"
          },
          property: "value"
        }
      ]
    };
  }
};
</script>

<style></style>
